import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TabList, TabsModule } from '@openng/optimus-ui/tabs';
import { MenuItem } from '../menu/menu-item';

@Component({
  selector: 'core-nav-bar',
  imports: [RouterModule, TabsModule],
  template: `
    @if (menu().length) {
      <nav>
        <p-tabs [value]="activeRouterLink()" showNavigators="false">
          <p-tablist>
            @for (item of menu(); track item.routerLink) {
              <p-tab [value]="item.routerLink">
                <a
                  [routerLink]="item.routerLink"
                  routerLinkActive
                  #rla="routerLinkActive"
                  [attr.aria-current]="rla.isActive ? 'page' : null"
                  (isActiveChange)="onIsActiveChange(item.routerLink, $event)"
                >
                  @if (item.icon) {
                    <span class="material-icons">{{ item.icon }}</span>
                  }
                  <span>{{ item.label }}</span>
                </a>
              </p-tab>
            }
          </p-tablist>
        </p-tabs>
      </nav>
    }
  `,
  styles: [
    `
      p-tab {
        @apply p-0;
      }

      p-tab a {
        @apply flex items-center;
        gap: var(--p-tabs-tab-gap);
        padding: var(--p-tabs-tab-padding);
      }

      p-tab a .material-icons {
        @apply w-[1em] overflow-hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBarComponent {
  public readonly menu = input<MenuItem[]>([]);

  protected readonly activeRouterLink = signal<string | undefined>(undefined);

  private readonly tabList = viewChild(TabList);
  private readonly _inkBarRealignedOnceFontsLoad = effect(() => {
    const tabList = this.tabList();
    if (!tabList || !this.activeRouterLink()) {
      return;
    }

    // The ink bar width is measured in JS, so it keeps the wider pre-webfont tab width
    document.fonts.ready.then(() => tabList.updateInkBar());
  });

  protected onIsActiveChange(routerLink: string, isActive: boolean) {
    if (isActive) {
      this.activeRouterLink.set(routerLink);
      return;
    }

    if (this.activeRouterLink() === routerLink) {
      this.activeRouterLink.set(undefined);
    }
  }
}
